var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"l-container"},[_vm._t("body"),_vm._v(" "),(_vm.isBread)?_c('common-breadcrumb',{attrs:{"heading":_vm.breadHeading,"breadcrumbType":'default'}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }